import Echo from 'laravel-echo'
import bootbox from 'bootbox';

window.io = require('socket.io-client');
window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: window.location.hostname + ':6001'
});

$(document).ready(function(e){

    let $notifications = $('.notifications'),
        user_id = parseInt($notifications.attr('data-user-id')),
        tenant = window.tenant,
        infinite_scroll = $notifications.attr('data-infinite-scroll');

    if(infinite_scroll){
        initInfiniteScroll();
    }

    window.Echo.channel('notifications')
        .listen('NotificationEvent', (payload) => {
            handleNotificationPayload(payload);
        });

    function initInfiniteScroll(){
        $('.notifications').on('scroll', function(e){
            if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
                let notifications_count = parseInt($notifications.attr('data-notify-count'));

                $.ajax({
                    type : 'GET',
                    url : '/notifications',
                    data : {
                        skip : notifications_count,
                    },
                    success : function(res){
                        if(res){
                            $notifications.attr('data-notify-count', notifications_count + res.count);
                            $('.notifications').append(res.notifications);
                        }else{
                            $('.notifications').off('scroll');
                        }
                    }
                })
            }
        })
    }

    function handleNotificationPayload(payload){
        if(payload.type === 'notification' && parseInt(payload.user_id) === parseInt(user_id) && payload.tenant === tenant){

            let $notify_count = $('.notify-count'),
                $bell = $('.bell'),
                value = parseInt($notify_count.text()) + 1;

            let notifications_count = parseInt($notifications.attr('data-notify-count')) + 1;

            $.ajax({
                type : 'GET',
                url : `/notification/${payload.id}/render`,
                success : function(rendered){
                    $(rendered).insertAfter('.notifications .header');
                    $bell.addClass('ring');
                    $notify_count.text(value);
                    $notifications.attr('data-notify-count', notifications_count);
                }
            });
        }else if(payload.type === 'message' && parseInt(payload.user_id) === parseInt(user_id) && payload.tenant === tenant){
            $.ajax({
                type : 'GET',
                url : `/message/${payload.id}/render`,
                success : function(res){
                    $('#message-body').empty().html(res.render);
                    $('#view-message').attr('data-url', res.url);
                    $('#message-modal').modal('show');
                }
            });
        }else if(payload.type === 'sync_complete' && parseInt(payload.user_id) === parseInt(user_id) && payload.tenant === tenant){
            bootbox.alert(payload.message);
        }else if(payload.type === 'erp_sync_complete' && parseInt(payload.user_id) === parseInt(user_id) && payload.tenant === tenant){
            $(`.sync-get-integration[data-action-id="${payload.action_id}"]`).removeClass('d-none');
            $(`.syncing-facade[data-action-id="${payload.action_id}"]`).addClass('d-none');
            bootbox.alert(payload.message);
        }else if(payload.type === 'erp_sync_failed' && parseInt(payload.user_id) === parseInt(user_id) && payload.tenant === tenant){
            $(`.sync-get-integration[data-action-id="${payload.action_id}"]`).removeClass('d-none');
            $(`.syncing-facade[data-action-id="${payload.action_id}"]`).addClass('d-none');
            bootbox.alert(payload.message);
        }else if(payload.type === 'mail_sync_progress' && parseInt(payload.user_id) === parseInt(user_id) && payload.tenant === tenant){
            $('.progress-bar').css('width', payload.percentage+'%').attr('aria-valuenow', payload.percentage).text(payload.percentage + '%');
            if(parseInt(payload.percentage) === 100){
                $('.sync-progress').addClass('d-none');
                $('.syncing-indicator').addClass('d-none');
            }
        }
    }

    $('body').on('click', '.notification', function(e){
        e.preventDefault();

        let $target = $(e.target);

        if(
            !$target.hasClass('show-dropdown-content') &&
            !$target.hasClass('notify-unread')
        ){
            e.stopPropagation();

            let url = $(this).attr('data-action'),
                id = $(this).attr('data-notification');

            $.ajax({
                type : 'POST',
                url : `/notification/${id}/read`,
                success : function(res){
                    if(res){
                        window.location = url;
                    }
                }
            })
        }
    });

    $(document).on('click', '.notifications', function (e) {
        e.stopPropagation();
    });

    $(document).on('click', '.notify-unread', function (e) {
        let id = $(this).attr('data-notification'),
            $notification = $(this).parents('.notification'),
            $action_dropdown = $(this).parents('.action-dropdown'),
            $bell = $('.bell'),
            $notify_count = $('.notify-count'),
            value = parseInt($notify_count.text()) + 1;
        $.ajax({
            type : 'POST',
            url : `/notification/${id}/unread`,
            success : function(res){
                if(res){
                    $notification.addClass('un-read');
                    $action_dropdown.addClass('d-none');
                    $bell.addClass('ring');
                    $notify_count.text(value);
                }
            }
        })
    });

    $('#read-notifications').on('click', function(e){
        e.preventDefault();

        let $notify_count = $('.notify-count');

        $.ajax({
            type : 'POST',
            url : '/notification/read',
            success : function(res){
                if(res){
                    let $notifications = $('.notification.un-read');
                    $($notifications).each(function(i, $notification){
                        $($notification).removeClass('un-read').addClass('read');
                        $($notification).find('.action-dropdown').removeClass('d-none');
                    });
                    $('.bell').removeClass('ring');
                    $notify_count.text(0);
                }
            }
        });
    });

    $('#cancel-message').on('click', function(e){
        $('#message-modal').modal('hide');
    });

    $('#view-message').on('click', function(e){
        let url = $(this).attr('data-url');

        if(url.length){
            window.location = url;
        }
    })
});